import { ReactElement } from 'react';

import { PractitionerView, PractitionerViewQuery } from '@dreryk/egabinet-personnel-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { Loader, LoaderSize, Message, MessageType, StyledFlex } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { doctorsMappingsTranslationKeys } from '../../translations';

const usePractitionersQuery = (): UseCqrsQueryResult<PractitionerView[]> => {
   return useCqrsSearch<PractitionerView>(() => {
      const practitionerViewQuery = new PractitionerViewQuery();
      practitionerViewQuery.jobPositions = Slot.of(['DOCTOR']);
      return practitionerViewQuery;
   });
};

type PractitionersLoaderRenderProps = { practitioners: PractitionerView[] };

type PractitionersLoaderProps = {
   readonly children: (props: PractitionersLoaderRenderProps) => ReactElement;
};

export const PractitionersLoader = (props: PractitionersLoaderProps): ReactElement => {
   const { data: practitioners, loading: practitionersLoading, error: practitionersError } = usePractitionersQuery();

   if (practitionersLoading) {
      return (
         <StyledFlex alignItems={'center'} justifyContent={'center'}>
            <Loader testId={'practitioners'} size={LoaderSize.MEDIUM} />
         </StyledFlex>
      );
   }

   if (practitionersError) {
      return (
         <Message
            testId={'practitionersFetchError'}
            type={MessageType.NEGATIVE}
            label={doctorsMappingsTranslationKeys.practitionersFetchFault}
         />
      );
   }

   return props.children({ practitioners: practitioners });
};
